import type { ImageCarouselProps } from "@/app/features/shared/image-carusel/types/types";
import ImageCarouselBase from "@/app/features/shared/image-carusel/ui/shared/ImageCarouselBase.client";

export default function ImageCarouselPublic({ images }: ImageCarouselProps) {
    return (
        <ImageCarouselBase
            images={images}
            autoScroll
            loop
            openModalGallery
        />
    );
}
